import React from 'react';
import find from 'lodash/find';
import cn from 'classnames';
import { Checkbox } from '@els/els-react--checkbox';
import { TextInput } from '@els/els-react--text-input';
import PropTypes from 'prop-types';
import DialogRow from '@Pages/RetroSynthesis/ExportRoute/components/DialogRow';
import EXPORT_FORM_DESCRIPTION_OPTION from './ExportOptionsConstants';

import './ExportOptions.scss';

function ExportOptions({ additionalOptions = [], setSelectedOptions, exportFormDescription, setExportFormDescription }) {
  return (
    <DialogRow label="Additional options:" className="export-options">
      <div className="rx-flex-column-container export-options__container">
        {additionalOptions.map((option) => (
          <Checkbox
            label={option.label}
            key={option.name}
            data-e2e={`export-dialog-option${option.label}`}
            onChange={(event) => {
              setSelectedOptions(
                additionalOptions.map((o) => ({ ...o, checked: o.name !== option.name ? o.checked : event.target?.checked }))
              );
            }}
            checked={option.checked || false}
            className={cn('export-options__checkbox', `e2e-export-dialog-option${option.label}`)}
          />
        ))}
        {find(additionalOptions, { name: EXPORT_FORM_DESCRIPTION_OPTION.name, checked: true }) && (
          <TextInput
            className="export-options__input"
            label="Description"
            shouldHideLabel
            data-e2e="export-dialog-description-input"
            value={exportFormDescription}
            onChange={(event) => setExportFormDescription(event?.target?.value ?? event?.currentTarget?.value ?? '')}
          />
        )}
      </div>
    </DialogRow>
  );
}

export default ExportOptions;

ExportOptions.propTypes = {
  additionalOptions: PropTypes.array,
  setSelectedOptions: PropTypes.func,
  exportFormDescription: PropTypes.string,
  setExportFormDescription: PropTypes.func,
};
